export function handleMouseDown(e, refMove) {
  const elementRefMove = document.querySelector(refMove);
  if (elementRefMove) {
    const diffX = e.clientX - elementRefMove.offsetLeft;
    const diffY = e.clientY - elementRefMove.offsetTop;
    document.onmousemove = function(e) {
      // 浏览器兼容
      e = e || window.event;
      let left = e.clientX - diffX;
      let top = e.clientY - diffY;

      if (left < 0) {
        left = 0;
      } else if (left > window.innerWidth - elementRefMove.offsetWidth) {
        left = window.innerWidth - elementRefMove.offsetWidth;
      }
      if (top < 0) {
        top = 0;
      } else if (top > window.innerHeight - elementRefMove.offsetHeight) {
        top = window.innerHeight - elementRefMove.offsetHeight;
      }
      elementRefMove.style.left = left + 'px';
      elementRefMove.style.top = top + 'px';
    };
    // 当鼠标抬起时
    document.onmouseup = function(e) {
      this.onmousemove = null;
      this.onmouseup = null;
    };
  }
};

export function initMoveModalLeft(refMoveString, width) {
  const initRefMove = document.querySelector(refMoveString);
  if (initRefMove) {
    if (initRefMove.style.left === '') {
      initRefMove.style.left = ((window.innerWidth - width) / 2) + 'px';
    }
  }
};
